<template>
  <v-row class="good3-flex--bg" align="center" justify="center">
    <v-col cols="10" class="py-2 px-0">
      <v-card
        class="d-flex flex-no-wrap ml-3 pa-1"
        max-width="400"
        flat
        outlined
      >
          <v-avatar
            size="66"
            tile
            style="border-radius: 4px"
          >
            <v-img :src="require('../../assets/vendors/blizzard/' + getPortraitImage(hero))"></v-img>
          </v-avatar>
          <div>
            <v-card-title class="body-1 py-0 px-2">{{ hero.name }}</v-card-title>
            <hero-dth-badge
              v-bind:damage="hero.stats.damage"
              v-bind:toughness="hero.stats.toughness"
              v-bind:healing="hero.stats.healing"
            ></hero-dth-badge>
          </div>
          <div>
            <v-card-title class="body-1 py-0 px-2">
              {{ hero.level }}
              <div
                class="good3-chipsParangon ml-2"
                v-bind:class="{
                  'good3-hc': hero.hc, 'lighten-1': hero.hc,
                  'indigo': !hero.hc, 'lighten-2': !hero.hc
                }"
              >
                {{ hero.parangon }}
              </div>
            </v-card-title>
            <v-card-subtitle class="caption py-0 px-2">
              seen {{ howLongAgo(hero.last_updated) }}
            </v-card-subtitle>
          </div>
      </v-card>
    </v-col>
    <v-col cols="2" class="py-2 px-0">
      <v-card
        flat
        outlined
        height="76"
      >
        <v-row class="px-0 py-2 ma-0" align="center" justify="center">
          <v-col cols="6" class="pa-0 ma-0 text-center">
            <span
              class="good3-heroListProperty"
              v-bind:class="{
                'good3-icon-hc--text': (hero.hc && !hero.dead),
                'good3-icon-empty--text': !hero.hc,
              }"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on">mdi-skull-crossbones</v-icon>
                </template>
                <span>{{ tooltipHardcore }}</span>
              </v-tooltip>
            </span>
          </v-col>
          <v-col cols="6" class="pa-0 ma-0 text-center">
            <span
              class="good3-heroListProperty"
              v-bind:class="{
                'good3-icon-season--text': (hero.sea && isCurrentSeason),
                'good3-icon-empty--text': !wasSeasonnal,
              }"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on">mdi-leaf</v-icon>
                  <span v-if="wasSeasonnal" class="good3-heroListProperty-seasonNumber">{{ hero.original_season }}</span>
                </template>
                <span>{{ tooltipSeason }}</span>
              </v-tooltip>
            </span>
          </v-col>
        </v-row>
        <v-row class="px-0 py-2 ma-0" align="center" justify="center">
          <v-col cols="6" class="pa-0 ma-0 text-center">
            <span
              class="good3-heroListProperty"
              v-bind:class="{
                'good3-icon-empty--text': !(hero.sea && !isCurrentSeason)
              }"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on">mdi-grave-stone</v-icon>
                </template>
                <span>{{ tooltipDeleted }}</span>
              </v-tooltip>
            </span>
          </v-col>
          <v-col cols="6" class="pa-0 ma-0 text-center">
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// MIXINS
import { ProfileLib } from '../../good3lib/profile_lib'
import { HeroLib } from '../../good3lib/hero_lib'

// VUEX
import { mapGetters } from 'vuex'

// COMPONENTS
import HeroDTHBadge from './HeroDTHBadge.vue'

// DEFAULT
export default {
  name: 'GOOD3_PROFILE_HERO_LIST_ITEM',

  // Importing VUEJS shared resources
  // • props for input
  // • components for sub vue components
  // • mixins for methods libraries
  props: {
    hero: Object
  },
  components: {
    'hero-dth-badge': HeroDTHBadge
  },
  mixins: [ProfileLib, HeroLib],

  // Accessible properties:
  // • data
  // • computed
  // • watch
  data: () => ({
  }),
  computed: {
    // FROM VUEX
    ...mapGetters([
      'armoryHeroes'
    ]),

    isDeleted: function () {
      return (this.hero.sea && (this.hero.original_season < 19))
    },

    isCurrentSeason: function () {
      return (this.hero.original_season === 19)
    },

    wasSeasonnal: function () {
      return (this.hero.original_season > 0)
    },

    tooltipDeleted: function () {
      if (!(this.hero.sea && this.wasSeasonnal)) {
        return 'Hero has not been deleted.'
      } else {
        return 'Hero has been deleted and is no longer listed in the game.'
      }
    },

    tooltipSeason: function () {
      if (!this.wasSeasonnal) {
        return 'Hero has not been created for a season.'
      } else {
        if (this.hero.sea && this.isCurrentSeason) {
          return 'Hero participates to the current season (season ' + this.hero.original_season + ').'
        } else {
          return 'Hero was created for season ' + this.hero.original_season + '.'
        }
      }
    },

    tooltipHardcore: function () {
      if (this.hero.hc && !this.hero.dead) {
        return 'Hero is played Hardcore mode and is not dead ... yet :)'
      } else {
        if (!this.hero.hc) {
          return 'Hero is a softcore hero, he can die alright.'
        } else {
          return 'Hero is being remembered for his bravery but is now dead :('
        }
      }
    }
  },
  watch: {},

  // VUEJS lifecycle hooks
  //
  // • created
  // • mounted
  mounted () {
  },

  // Components methods
  methods: {
  }
}
</script>

<style scoped>

</style>
